export const videoComments = (videoId, comments) =>
  comments.filter((comment) => videoId === comment.video);
